import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Title = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.lineHeight};
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
`;

interface OptionProps {
  $selected?: boolean;
  $alternativeNoBackgroundStyles?: boolean;
}

export const Option = styled.span<OptionProps>`
  display: flex;
  padding: 0.375rem 0.5rem;
  border-radius: 0.375rem;
  font-size: ${(props: ThemeProp & { $selected?: boolean }) => props.theme.fontSize.s};
  line-height: 1.1375rem; // Design specs
  color: ${(props: ThemeProp & { $selected?: boolean }) =>
    props.$selected ? props.theme.colors.main.c600 : props.theme.colors.neutrals.c600};
  background-color: ${(props: ThemeProp & { $selected?: boolean }) =>
    props.$selected ? props.theme.colors.main.c100 : props.theme.colors.neutrals.c100};
  cursor: pointer;

  ${(props: ThemeProp & OptionProps) =>
    props.$alternativeNoBackgroundStyles &&
    `
    background-color: ${props.$selected ? props.theme.colors.main.c050 : 'transparent'};
    font-weight: ${props.$selected ? props.theme.fontWeight.semibold : props.theme.fontWeight.regular};
    color: ${props.$selected ? props.theme.colors.main.c600 : props.theme.colors.content.default};
  `}
`;

export const WrapContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  max-width: 100%;
  flex-wrap: wrap;
`;
